import { render, staticRenderFns } from "./OptionCreate.vue?vue&type=template&id=c1dec2f4"
import script from "./OptionCreate.vue?vue&type=script&lang=js"
export * from "./OptionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports